module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAWlBMVEUAAABBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiND///9UlNXi7fjP4fNamNbp8frY5/XT4/RMj9P2+f261O5mn9lNj9NIjdID+dXMAAAAD3RSTlMAVAb64NqsiVvkA/OmlAcfddGbAAAAj0lEQVQY022Q7Q6DIAxFS4GKqCsMN/f5/q+5UAkjyvnT3BOaXAoCqtnoyc4KoaIsF6wqyg/cMHiR2bVWdvmAAsDxKEcExyccUJM+6Z0Hgfm7xz1seRrQktfXN7trzEHDJDKFFDdxIu3+8hae4vZ14mKrY6qV1hRrpV75S/+b/YOAX1q3+N6RK+jIaG3IocQfE8kSaKI5KR0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_save_hover.png
// module id = f3hm
// module chunks = 9